import React from "react";

import styles from "./Info.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";

const Info: React.FC = () => {
  return (
    <section className={styles.info}>
      <div className="container">
        <PreviousPage currentPage="Доставка и оплата" title="Доставка и оплата" />
        <p className={styles.text}>
          При оформлении заказа менеджер поможет выбрать наиболее удобный и выгодный для вас способ доставки
        </p>
        <div className={styles.body}>
          <div className={styles.left}>
            <div className={styles.item}>
              <h3 className={styles.subTitle}>Доставка тканей</h3>
              <p className={styles.text}>осуществляется только после 100% предоплаты</p>
            </div>
            <div className={styles.item}>
              <h3 className={styles.subTitle}>Доставка фурнитуры</h3>
              <p className={styles.text}>Минимальная сумма заказа фурнитуры 500 рублей.</p>
              <p className={styles.text}>Предоплата 500 рублей.</p>
              <p className={styles.text}>При сумме заказа более 5 000 рублей — предоплата 10% от общей суммы заказа.</p>
            </div>
          </div>
          <div className={styles.right}>
            <p>Работаем по договору с Почтой России, СДЭК.</p>
            <div className={styles.deliveryLogos}>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/russianPost.jpg" alt="russianPost" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/cdek.png" alt="cdek" />
              </div>
            </div>
            <p>
              По вашему желанию отправка груза может осуществляться другой транспортной компанией — Сбер-Логистика, DHL, EMS,
              Деловые линии, ЦАП, ПЭК, Энергия, DPD, КИТ, Байкал Сервис.
            </p>
            <div className={styles.logos}>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/sber.png" alt="sber" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/dhl.png" alt="dhl" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/ems.png" alt="ems" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/dpd.png" alt="dpd" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/energiya.jpg" alt="energiya" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/pek.png" alt="pek" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/cap.jpg" alt="cap" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/kit.jpg" alt="kit" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/dl.png" alt="dl" />
              </div>
              <div className={styles.logo}>
                <img src="/img/main/delivery-and-payment/baikal.png" alt="dhl" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Info;
